// Only an in-page catalog drag is accepted. Plain text, files and foreign drags
// never become casting assignments, even if they contain a valid voice ID.
export const VOICE_DRAG_TYPE = 'application/x-tableread-voice';
